import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.label,
      item: item.href ? `https://mimeimanga.com${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <nav aria-label="面包屑导航" className="max-w-[1400px] mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center gap-1.5 text-xs text-foreground-500">
          {items.map((item, i) => (
            <li key={i} className="flex items-center gap-1.5">
              {i > 0 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
              {item.href ? (
                <Link to={item.href} className="hover:text-primary-600 transition-colors whitespace-nowrap">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-700 font-medium whitespace-nowrap">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}